import { useAppAuth } from "./app/AppAuth";
import { useAppRealtime } from "./app/AppRealtime";
import { AppRouter } from "./app/AppRouter";
import UploadProgressOverlay from "./components/UploadProgressOverlay";
import FetchProgressBar from "./components/FetchProgressBar";

/**
 * Main Application Component (AdaptHub v2) — thin shell.
 *
 * Composes the three root concerns extracted into `src/app/`:
 *   - `useAppAuth`     — Supabase session, Apaleo token exchange, tenant config
 *   - `useAppRealtime` — offline state + admin force-reload listener
 *   - `AppRouter`      — route protection / top-level render decision tree
 *
 * Navigation helpers (`NavGroup`, `NavItem`, `NavItemsList`) and the
 * `SystemLogsView` / `LogRow` pair now live in `src/app/AppNav.jsx` and
 * `src/app/SystemLogsView.jsx` respectively.
 *
 * @returns {JSX.Element} The root App component.
 */
export default function App() {
  const auth = useAppAuth();
  const { isOffline } = useAppRealtime(auth.user);
  return (
    <>
      <AppRouter {...auth} isOffline={isOffline} />
      {/* Global upload progress chip — every uploadWithValidation() call
          publishes to src/utils/uploadProgressBus.ts; this overlay shows a
          compact per-file progress chip app-wide (2026-10-01). */}
      <UploadProgressOverlay />
      {/* Global fetch-progress bar — big API pulls (Apaleo pagination,
          Supabase lists) publish jobs to src/stores/fetchProgressStore.ts;
          the bar shows page progress or an elapsed-time sweep so users know
          the backend is alive (owner request 2026-10-08). */}
      <FetchProgressBar />
    </>
  );
}
